import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Permission } from 'src/app/constants/permission.constant';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-filter-shared-action',
  templateUrl: './filter-shared-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class FilterSharedActionComponent {
  @Input() isSharedFilter: boolean = false;
  @Output() toggled = new EventEmitter<void>();

  Permission = Permission;

  constructor(public authService: AuthService) {}

  onToggle(): void {
    this.toggled.emit();
  }
}
